import CoursesFilterDropdown from '@/pages/common/dropdowns/multiselectDropdown/courses-name-dropdown-filter/CoursesFilterDropdown.vue'
import GroupsFilterDropdown from '@/pages/common/dropdowns/multiselectDropdown/groups-dropdown-filter/GroupsFilterDropdown.vue'
import LessonsFilterDropdown from '@/pages/common/dropdowns/multiselectDropdown/lessons-dropdown-filter/LessonsFilterDropdown.vue'

export const dropdownResultCoursesComponents = {
  CoursesFilterDropdown,
  GroupsFilterDropdown,
  LessonsFilterDropdown,
}
